import axios from "axios";
import {API_DOMAIN} from "../constants";
import {urlParseParams} from "../util/StringUtil";

export async function getFacilities({page, size, businessUnitCodes}) {
    const params = {
        page,
        size,
        businessUnitCodes: businessUnitCodes && businessUnitCodes.length > 0 ? businessUnitCodes.join(",") : undefined,
    };
    const response = await axios({
        url: API_DOMAIN + "/api/v2/facilities/adminPortal?" + urlParseParams(params),
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return {
        facilities: response.data,
        totalCount: parseInt(response.headers["x-total-count"]),
    };
}

export async function getFacility(id) {
    const response = await axios({
        url: API_DOMAIN + `/api/v2/facilities/${id}`,
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}

export async function createFacility(payload) {
    return axios({
        url: API_DOMAIN + "/api/v2/facilities",
        method: "POST",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}

export async function updateFacility(payload) {
    return axios({
        url: API_DOMAIN + "/api/v2/facilities",
        method: "PUT",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
        data: payload,
    });
}

export async function getFacilityUsers(facilityId) {
    const response = await axios({
        url: API_DOMAIN + `/api/v2/facilities/${facilityId}/users`,
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}

export async function deleteFacilityUsers(facilityId, userIds) {
    return axios({
        url: API_DOMAIN + `/api/v2/facilities/${facilityId}/users?userIds=${userIds.join(",")}`,
        method: "DELETE",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });
}

export async function addFacilityUsers(facilityId, userIds) {
    return axios({
        url: API_DOMAIN + `/api/v2/facilities/${facilityId}/users?userIds=${userIds.join(",")}`,
        method: "PUT",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });
}

export async function searchUsers(page, size, searchString, businessUnitCode) {
    const params = {
        page,
        size,
        searchString,
        businessUnitCode,
    };
    const response = await axios({
        url: API_DOMAIN + "/api/v2/users?" + urlParseParams(params),
        method: "GET",
        headers: {
            Authorization: localStorage.getItem("MFE_TOKEN"),
        },
    });

    return response.data;
}
